export default "__VITE_ASSET__DhU4UljD__"